/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const customize = {
    updatePriceDisplay: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'Update price display for $0 in products and suggestions',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        // Update Product List
                                                  let productData = element.getParams().props.product;
                        const updateProductListPrices = () => {

                            let productItems = document.querySelectorAll('.boost-sd__product-item[data-product-id="' + productData.id + '"]');
                            if (productData && productItems) {
                                if (productData.price === 0 || productData.price_min === 0) {
                                    productItems.forEach(function(productItem) {
                                        const priceElement = productItem.querySelector('.boost-sd__product-price');
                                        if (priceElement) {
                                            priceElement.textContent = "In-Store Only";
                                        }
                                        // ATC button
                                        const atcElement = productItem.querySelector('.boost-sd__btn-add-to-cart');
                                        if (atcElement) {
                                            atcElement.remove();
                                        }
                                    });
                                }
                            }
                        };
                        updateProductListPrices();
                      const elm = element.getRootElm()
                                      if(productData.variants[0].inventory_management == null && elm.querySelector(".boost-sd__inventory-status")) {
                                        elm.querySelector(".boost-sd__inventory-status").innerHTML = "In Stock"
                                      }
                    } catch (error) {
                        console.error("Error in updating prices:", error);
                    }
                }
            }),
        });
        componentRegistry.useComponentPlugin('QuickView', {
            name: 'Update price display for $0 in products and suggestions',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        const productData = element.getParams().props.productData;
                        if (productData) {
                            const quickViewElm = document.querySelector('.boost-sd__quick-view[product-id="' + productData.id + '"]');
                            if (quickViewElm && (productData.price === 0 || productData.price_min === 0)) {
                                // Quantity & ATC button
                                const quantityElement = quickViewElm.querySelector('.boost-sd__quick-view-quantity');
                                if (quantityElement) {
                                    quantityElement.remove();
                                }
                                // ATC
                                const atcElement = quickViewElm.querySelector('.boost-sd__quick-view-btn');
                                if (atcElement) {
                                    atcElement.remove();
                                }
                                // Price
                                const priceElement = quickViewElm.querySelector('.boost-sd__quick-view-price');
                                if (priceElement) {
                                    priceElement.remove();
                                }
                            }
                        }
                    } catch (error) {
                        console.error("Error in updating prices:", error);
                    }
                }
            }),
        });
    }
};
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updatePriceDisplay]);
const customizeSearch = {
    updatePriceDisplay: (componentRegistry) => {
        componentRegistry.useComponentPlugin('SearchProductItem', {
            name: 'Update price display for $0 in products and suggestions',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        // Update Product List
                        const updateSuggestionPrices = () => {
                            let productData = element.getParams().props.product;
                            let productItem = document.querySelector('.boost-sd__suggestion-queries-item[data-id="' + productData.id + '"]');
                            if (productData && productItem) {
                                if (productData.price === 0 || productData.price_min === 0) {
                                    const priceElement = productItem.querySelector('.boost-sd__suggestion-queries-item-price');
                                    if (priceElement) {
                                        priceElement.textContent = "In-Store Only";
                                    }
                                }
                            }
                        };
                        updateSuggestionPrices();
                    } catch (error) {
                        console.error("Error in updating prices:", error);
                    }
                }
            }),
        });
    }
};
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customizeSearch.updatePriceDisplay]);


window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useModulePlugin("CartAPI", {
      name: "Custom onSucces add to cart",
      apply(builder) {
        builder.on("methodFulfilled", "addToCart", async (payload) => {
         document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
            bubbles: true, // same code for prestige theme
        }),
        );
        setTimeout(function() {
            fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        updates: {},
                        sections: ["cart-drawer", "cart-icon-bubble"]
                    }),
                })
                .then((res) => res.json())
                .then((cart) => {
                    document.querySelector("cart-drawer").renderContents(cart);
                    document.querySelector("cart-drawer.drawer").classList.remove("is-empty");
                });
            // document.querySelector('a[href="/cart"]').click();
        }, 500);
        });
      },
    });
  },
]);